import { template } from "underscore";

export class Gallery {

    layerClass = 'lity-gallery';
    isOpen = false;

    figcaptionTPL = template([
        '<div class="lity-caption">',
        '<div class="figcaption"><%= figcaption %></div>',
        '</div>'
    ].join(''));

    // staff
    figcaption;
    body;
    cardId;

    constructor() {
        this.init();
    }

    init() {
        const items = $('.gallery__item');

        if (!items.length) {
            return;
        }

        this.body = $('body');

        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('lity:open', (e) => this.onOpen(e))
            .on('lity:remove', (e) => this.onRemove(e))
            .on('click', '.gallery__item', (e) => this.onClick(e));

        $(window).on('page-slider-view page-view-slide-change', (args) => this.onSlideChange(args));
    }

    onClick(e) {
        this.isOpen = true;
        this.figcaption = $(e.currentTarget).find('figcaption').html() || '';
        this.body.addClass('gallery--active');
        this.cardId = $(e.currentTarget).attr("data-relation-id");
    }

    onOpen(e) {
        const share3 = $('.author-card .share-tool').eq(0).clone(true);
        let share3html = share3.html();

        // OJO puede tener sentido en algún caso. Ahora estropea las cards
        /*let stringURL = window.location.href;
        let stringURLwithoutHash = stringURL.substr(0, stringURL.indexOf('#'));
        stringURL = stringURL.replace('#', '%23');
        if (stringURLwithoutHash) {
            stringURLwithoutHash = stringURL;
        }
        share3html = share3html.replace(new RegExp(stringURL, "g"), stringURLwithoutHash);
        share3html = share3html.replace(new RegExp(stringURLwithoutHash, "g"), stringURLwithoutHash + "%23card_" + this.cardId);*/

        if (this.isOpen) {
            this.body.addClass('gallery--active');

            $(e.target)
                .addClass(this.layerClass)
                .find('.lity-container')
                .append(this.figcaptionTPL({
                    figcaption: this.figcaption
                }), '<ul class="share-tool">' + share3html + '</ul>');
        }
    }

    onRemove(e) {
        if (this.isOpen) {
            this.body.removeClass('gallery--active');
            $(e.target).removeClass(this.layerClass);
            this.isOpen = false;
        }
    }

    onSlideChange(args) {
        const index = args.target.activeIndex;
        const ficaption = $(args.target.slides).eq(index).find('figcaption').html() || '';

        $('.page-view--data').html(ficaption);
    }
}
